<template>
  <div class="nights-step-acommodation-component">
    <nights-two-columns>
      <template v-slot:left>
        <div v-if="!isPackFlight">
          <div class="flex justify-between items-center mb-4 px-2">
            <h1 class="mt-4 mb-0 lg:mt-0 lg:mb-4">{{$t("hotel.hotels")}}</h1>
            <nights-room-selector></nights-room-selector>
          </div>
          <div class="hotels space-y-6">
            <hotel-card
              v-for="(hotel, index) in hotels"
              :key="index"
              :hotel="hotel"
              :adults="adults"
              :nights="nights"
              :destination="hotel.destinationName"
              :only-info="false"
              :class="{
                selected: hotelIsSelected(hotel.code),
                bordergrey: index != 0 && noHotelIsSelected,
                suggested: index == 0 && noHotelIsSelected,
              }"
              @open-dialog="openDialog(hotel)"
            >
            </hotel-card>
          </div>
        </div>
        <div v-else >
          <div class="flex justify-between items-center mb-4 px-2">
            <h3 class="heading-3 mb-0 lg:mb-4">{{$t("hotel.choose_hotel_categories")}}</h3>
          </div>
          <div v-for="(hotels, level) in packHotels" :key="level" >
            <div
              v-if="level !== '' && level !== 'null'"
              class="hotels-pack-container border bg-white border-grey p-5 rounded-2xl mb-5 cursor-pointer"
              @click="selectCategory(level)"
              :class="{ 'hotel-selected': selectedCategory && selectedCategory.name === level }"
            >
              <div class="border-b border-grey py-3 flex justify-between items-baseline">
                <div>
                  <p class="font-bold mb-2">{{ $t(`hotel.hotel_${level}`) }}</p>
                  <p>{{ $t(`hotel.hotel_subtitle_${level}`) }}</p>
                </div>
                <div class="font-bold" :class="{ 'bg-black py-2 px-4 text-white rounded-xlg': level === 'luxury' }">{{ level === 'standard' ? $t('wizard_shared.included') : `+${extraLuxury}€` }}</div>
              </div>
              <div v-if="hotels">
                <hotel-pack-card
                  v-for="(hotel, index) in hotels"
                  :key="index"
                  :hotel="hotel"
                  :adults="adults"
                  :nights="nights"
                  :only-info="true"
                  :destination="hotel.destinationName"
                  @open-dialog="openDialog(hotel)"
                ></hotel-pack-card>
              </div>
              <div v-else>
                <p>{{ $t(`no_hotels_category_${level}`) }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:right>
        <box-summary :selectedCategory="selectedCategory" :packHotels="packHotels" :extraNoPromoPercentage="extraNoPromoPercentage" :totalPrice="totalPrice" :totalPriceLuxury="totalPriceLuxury">
            <v-btn
              rounded
              light
              elevation="0"
              color="secondary"
              block
              class="avm-btn mx-auto"
              :loading="loading"
              @click="clearHotel"
            >
              <span v-if="!isPackFlight">{{$t("wizard_more_days.continue_without_a_hotel")}}</span>
              <span v-else>{{$t("shared.continue")}}</span>
            </v-btn>
        </box-summary>
      </template>
    </nights-two-columns>

    <hotel-details-modal
      class="ml-0"
      :open="dialogIsOpen"
      @close="dialogIsOpen = false"
      :hotel="dialogHotel"
      :isPackFlight="isPackFlight"
    />
  </div>
</template>

<script>
import BoxSummary from "../common/BoxSummary.vue";
import HotelCard from "./HotelCard.vue";
import HotelDetailsModal from "./HotelDetailsModal.vue";
import NightsRoomSelector from "./RoomSelector.vue";
import NightsTwoColumns from "../common/NightsTwoColumns.vue";
import PopupAges from "./PopupAges.vue";
import Snackbar from "../../../components/Snackbar/Snackbar.vue";
import { goToStep } from "../mixins";
import { NIGHTS_SET_STATE, NIGHTS_SET_SELECTED_CATEGORY, NIGHTS_SET_PACK_HOTELS} from "../../../store/nights/mutation-types";
import { SET_AGE_TO_PASSENGER } from "../../../store/reserve-area/mutation-types";
import _ from "lodash";
import moment from 'moment';
import HotelPackCard from './HotelPackCard.vue';
import { mapGetters } from "vuex";
import { NIGHTS_GET_PACK_HOTELS, NIGHTS_GET_SELECTED_CATEGORY, NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD, NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY, NIGHTS_GET_IS_PACK_FLIGHT, NIGHTS_GET_LUXURY_EXTRA, GET_EXTRA_NO_PROMO_PRICE } from '../../../store/nights/getter-types';


export default {
  mixins: [goToStep],
  components: {
    BoxSummary,
    HotelCard,
    HotelPackCard,
    HotelDetailsModal,
    NightsTwoColumns,
    NightsRoomSelector,
    Snackbar,
    PopupAges,
  },
  data() {
    return {
      rooms: 1,
      dialogIsOpen: false,
      dialogHotel: null,
      passengersAges: [],
      selectedTotalPrice: null,
      isFixed: false
    };
  },
  props: {
    destination: {
      type: String,
      required: true,
    },
  },
  methods: {
    hotelIsSelected(code) {
      return this.$store.state.nights.hotel.code === code;
    },
    PackHotelsIsSelected(code) {
      return this.$store.state.nights.hotelsByCity;
    },
    openDialog(hotel) {
      console.log("opendialog:", this.dialogIsOpen);
      this.dialogHotel = hotel;
      this.dialogIsOpen = true;
    },
    clearHotel() {
      this.$store.commit(NIGHTS_SET_STATE, ["hotel", {}]);
      this.goToStep("extras");
    },
    selectCategory(category) {
      if (this.packHotels && this.packHotels[category]) {
        const hotels = this.packHotels[category];
        this.$store.commit(NIGHTS_SET_SELECTED_CATEGORY, { name: category, hotels });
        this.$emit('category-selected', this.selectedCategory);

      } else {
        console.warn("Hoteles no cargados aún. Esperando la carga...");
      }
    },
    handleScroll() {
      this.isFixed = window.pageYOffset >= 170;
    },
    processItinerary() {
      if (!this.$store.state.itineraries || this.$store.state.itineraries.length === 0) {
        console.error("No hay itinerarios disponibles.");
        return;
      }

      const selectedItinerary = this.$store.state.itineraries.find(
        itinerary => itinerary.days === parseInt(this.itinerary)
      );

      if (!selectedItinerary) {
        console.error("No se encontró un itinerario con estos días.");
        return;
      }

      this.$store.dispatch('fetchHotelsAndItinerary', {
        locationCode: this.destination,
        start: this.start,
        itinerary: selectedItinerary.id
      });
    },
    getItineraryId() {
        const selectedItinerary = this.itineraries.find(itinerary => itinerary.days === parseInt(this.itinerary));
        if (!selectedItinerary) {
            console.error("No se encontró un itinerario con estos días.");
            return null;
        }
        return selectedItinerary.id;
    }

  },
  computed: {
    ...mapGetters({
      packHotels: NIGHTS_GET_PACK_HOTELS,
      selectedCategory:NIGHTS_GET_SELECTED_CATEGORY,
      totalPrice: NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD,
      totalPriceLuxury: NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY,
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
      extraLuxury: NIGHTS_GET_LUXURY_EXTRA,
      extraNoPromoPercentage: GET_EXTRA_NO_PROMO_PRICE
    }),
    hotels() {
      return this.$store.state.nights.resources.hotels;
    },
    loading() {
      return this.$store.state.nights.loading;
    },
    hotel() {
      return this.$store.state.nights.hotel;
    },
    noHotelIsSelected() {
      return _.isEmpty(this.hotel);
    },
    adults(){
      return this.$store.state.nights.adults;
    },
    nights(){
      return moment(this.$store.state.nights.end).diff(moment(this.$store.state.nights.start), "days");
    },
    start() {
      return this.$route.query.start;
    },
    itinerary() {
      return this.$route.query.itinerary;
    },
    itineraries() {
        return this.$store.state.itineraries;
    }
  },
  created() {
    setTimeout(() => {
      if (this.thereAreChildsOrBabys) this.showDialogAges();
    }, 200);

  },
  mounted() {
    if (this.isPackFlight) {
        this.$store.dispatch('fetchItineraries', this.destination).then(() => {
            const itineraryId = this.getItineraryId();
            if (itineraryId) {
                this.$store.dispatch('fetchHotelsAndItinerary', {
                    locationCode: this.destination,
                    start: this.start,
                    itinerary: itineraryId
                });
            }
        });
    }

    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.heading-1 {
  margin-bottom: 0 !important;
}

.bordergrey{
  border: 1px solid #979797;
  border-radius: 15px;
}

.hotel-selected {
  border: 2px solid black ;
}

.fixed-top {
  position: fixed;
  top: 30px;
  transition: top 0.4s ease;
}
</style>
